import moment from "moment";

import {
  DELETE_REGISTRATION,
  GET_REGISTRATIONS,
  GET_LELOREGISTRATIONS,
  GET_REGISTRATION,
  ADD_LELO,
  UPDATE_LELO,
  GET_COURSEOPTIONCATALOG,
  GET_COURSEOPTIONCATALOGID,
  GET_COURSECATALOG,
  SEARCH_FILTERLELO,
  CLEAR_SEARCH_FILTERLELO,
  CLEAR_REGISTRATION,
  UPDATE_REGISTRATION,
  AGE_FILTER,
  SEARCH_FILTER,
  CLEAR_AGE_FILTER,
  CLEAR_SEARCH_FILTER,
  SET_LIST_VIEW,
  FILTER_TABLE,
  CLEAR_FILTER_TABLE,
  SET_FORM_MODAL,
  GET_ENROLLMENT_SITES,
  GET_SITE_PROGRAM,
  FILTER_ENROLLMENT_SITES,
  CLEAR_FILTER_ENROLLMENT_SITES,
  GET_REGISTRATION_ENTRIES,
  SET_LOADING_REG,
  SET_CURRENT_PAGE,
} from "../types";

const adminRegistrationReducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case "TOGGLE_SIDEBAR":
      return {
        ...state,
        sidebarOpen: !state.sidebarOpen,
      };
    case "SET_SIDEBAR":
      return {
        ...state,
        sidebarOpen: payload,
      };

    case "SELECT_ENROLLMENT_TYPE":
      return {
        ...state,
        formData: {
          ...state.formData,
          registerForIntercession: payload === "REGULAR" ? false : true,
        },
        subFormLevels: { ...state.subFormLevels, enrollmentType: 1 },
      };
    case "ON_FORM_DATA_CHANGE":
      return {
        ...state,
        formData: {
          ...state.formData,
          [payload.name]: payload.value,
        },
      };
    case "GET_AGE":
      return {
        ...state,
        formData: { ...state.formData, age: payload },
      };
    case "SET_TO_ENGLISH":
      return {
        ...state,
        formData: {
          ...state.formData,
          firstLanguage: "English",
          homeLanguage: "English",
          languageSpokenByParentsToStudent: "English",
          languageSpokenByAdultsAtHome: "English",
        },
      };
    case "SET_VALIDATION":
      return {
        ...state,
        validationCheck: payload,
      };
    case "SET_LOCATION_DATA":
      return {
        ...state,
        formData: {
          ...state.formData,
          learningCenterId: payload.id,
          learningCenterName: payload.name,
          learningCenterCharter: payload.charter,
          learningCenterAddress: payload.address,
          learningCenterCoordinates: payload.coordinates,
          brandName: payload,
        },
      };
    case "CLEAR_FORM_DATA":
      return {
        ...state,
        formData: {
          progressLevel: 0,
          processingLevel: 0,
          status: "",
          registerForIntercession: false,
          previouslyEnrolled: "",
          firstName: "",
          middleName: "",
          lastName: "",
          haveSuffix: { yes: false, no: false },
          suffix: "",
          gender: "",
          birthDate: "",
          age: "",
          gradeLevel: "",
          birthState: "",
          birthCountry: "",
          studentEmail: "",
          studentPrimaryPhone: "",
          studentPrimaryPhoneType: "",
          pgHighestLevelOfEducation: "",
          permissionParentContact: { yes: false, no: false },
          pgRelationshipToStudent: "",
          pgFirstName: "",
          pgLastName: "",
          pgPrimaryPhone: "",
          pgPrimaryPhoneType: "",
          pgPrimaryEmail: "",
          liveWithPg: "",
          livingStatus: "",
          street: "",
          city: "",
          state: "",
          zip: "",
          county: "",
          isMailingAddressTheSame: { yes: false, no: false },
          mailingStreet: "",
          mailingCity: "",
          mailingState: "",
          mailingZip: "",
          isStudentHispanicOrLatino: { yes: false, no: false },
          primaryRaceCategory: "",
          previousSchool: "",
          previousSchoolState: "",
          previousSchoolCity: "",
          primaryLanguage: "",
          firstLanguage: "",
          homeLanguage: "",
          languageSpokenByParentsToStudent: "",
          languageSpokenByAdultsAtHome: "",
          isPgEmployedInOneOrMoreAgriculturalOrFishingActivities: "",
          releaseAudioAndVideo: { yes: false, no: false },
          releasePermissionForSocialMedia: { yes: false, no: false },
          releaseUseStudentWork: { yes: false, no: false },
          releasePermissionToTextStudent: { yes: false, no: false },
          releasePermissionToTextPg: { yes: false, no: false },
          releaseAllowStudentAccessToGoogleAppsForEducation: {
            yes: false,
            no: false,
          },
          beenExpelled: { yes: false, no: false },
          expelledFromWhichSchool: "",
          expelledWhatYear: "",
          beenSuspended: { yes: false, no: false },
          suspendedFromWhichSchool: "",
          suspendedWhatYear: "",
          onProbation: { yes: false, no: false },
          isParentOrExpecting: { yes: false, no: false },
          moreThanThreeUnexcusedAbsences: { yes: false, no: false },
          lateToSchoolMoreThanThreeTimes: { yes: false, no: false },
          orderedToAttendSchool: { yes: false, no: false },
          orderedToAttendWhichSchool: "",
          orderedToAttendWhatYear: "",
          retainedMoreThanOnce: { yes: false, no: false },
          retainedFromWhichSchool: "",
          retainedFromWhatYear: "",
          droppedOutOfSchool: { yes: false, no: false },
          droppedOutFromWhichSchool: "",
          droppedOutFromWhatYear: "",
          behindSemesterInCredits: { yes: false, no: false },
          outOfSchoolMoreThanFortyFiveDays: { yes: false, no: false },
          expelledMoreThanTwoSchoolsPastYear: { yes: false, no: false },
          fosterCare: { yes: false, no: false },
          youthExperiencingHomelessness: { yes: false, no: false },
          accessToComputerAtHome: { yes: false, no: false },
          accessToTheInternetAtHome: { yes: false, no: false },
          knownHealthConditions: { yes: false, no: false },
          asthma: { yes: false, no: false },
          beeStingAllergy: { yes: false, no: false },
          diabetes: { yes: false, no: false },
          epilepsy: { yes: false, no: false },
          heartCondition: { yes: false, no: false },
          seizures: { yes: false, no: false },
          nutAllergy: { yes: false, no: false },
          knownHearingConditions: { yes: false, no: false },
          wearsHearingAid: { yes: false, no: false },
          knownEyeCondition: { yes: false, no: false },
          glassesToBeWornAtAllTimes: { yes: false, no: false },
          wearsContactLenses: { yes: false, no: false },
          wearsGlasses: { yes: false, no: false },
          medications: "",
          otherHealthCondition: "",
          medicalInstructions: "",
          heathInsuranceCarrier: "",
          insuranceIdOrPolicyNumber: "",
          hospitalPreference: "",
          custodyIssueExists: { yes: false, no: false },
          custodyIssueNotes: "",
          legalRestrictionsForAnyParent: { yes: false, no: false },
          legalRestrictionsNotes: "",
          emergencyContact1FirstName: "",
          emergencyContact1LastName: "",
          emergencyContact1Phone: "",
          emergencyContact1Relationship: "",
          authorizedForPickup1: { yes: false, no: false },
          emergencyContact2FirstName: "",
          emergencyContact2LastName: "",
          emergencyContact2Phone: "",
          emergencyContact2Relationship: "",
          authorizedForPickup2: { yes: false, no: false },
          learningCenterName: "",
          learningCenterCharter: "",
          learningCenterAddress: "",
          learningCenterCoordinates: "",
          learningCenterId: "",
          orientationScheduled: false,
          orientationType: "",
          orientationTime: "",
          orientationLink: "",
        },
      };
    case GET_ENROLLMENT_SITES:
      return {
        ...state,
        searchSites: payload,
      };

    case GET_SITE_PROGRAM:
      return {
        ...state,
        Siteprogram: payload,
      };
    case FILTER_ENROLLMENT_SITES:
      return {
        ...state,
        filteresSearchSites: state.searchSites.filter((item) => {
          const regex = new RegExp(`${payload}`, "gi");
          return (
            item.name.match(regex) ||
            item.charter.match(regex) ||
            item.address.address_1.match(regex) ||
            item.address.city.match(regex) ||
            item.address.state.match(regex) ||
            item.address.zip.match(regex)
          );
        }),
      };
    case CLEAR_FILTER_ENROLLMENT_SITES:
      return {
        ...state,
        filteresSearchSites: [],
      };
    case "GET_SCHEDULED_ORIENTATIONS":
      return {
        ...state,
        scheduledOrientations: payload,
        loading: false,
      };
    case GET_REGISTRATIONS:
      return {
        ...state,
        registrations: payload.regularRegistrations,
        allRegistrations: payload.allRegistrations,
        loading: false,
      };
    case GET_LELOREGISTRATIONS:
      return {
        ...state,
        LeloRegistrations: payload,
        filteredLELORegistrations: payload,
      };

    case GET_COURSEOPTIONCATALOG:
      return {
        ...state,
        CourseOptionCatalog: payload,
      };
    case GET_COURSEOPTIONCATALOGID:
      return {
        ...state,
        CourseOptionCatalogID: payload,
      };

    case ADD_LELO:
      return {
        ...state,
        LeloRegistrations: [...state.LeloRegistrations, payload],
      };
    case UPDATE_LELO:
      return {
        ...state,
        LeloRegistrations: state.LeloRegistrations.map((Lelo) =>
          Lelo._id === action.payload._id ? action.payload : Lelo
        ),
      };

    case GET_COURSECATALOG:
      return {
        ...state,
        CourseCatalog: payload,
      };

    case SEARCH_FILTERLELO:
      return {
        ...state,
        LeloRegistrations: state.filteredLELORegistrations.filter((Lelo) => {
          const escapedPayload = payload.replace(
            /[-[\]{}()*+?.,\\^$|#\s]/g,
            "\\$&"
          );
          const regex = new RegExp(`${escapedPayload}`, "gi");
          return (
            Lelo.name.match(regex) ||
            Lelo.status.match(regex) ||
            Lelo.schoolYear.match(regex)
          );
        }),
      };

    case CLEAR_SEARCH_FILTERLELO:
      return {
        ...state,
        LeloRegistrations: state.filteredLELORegistrations,
      };

    case "UPDATE_REGISTRATION_LIST_STATUS":
      return {
        ...state,
        completedRegistrations:
          payload === "completed"
            ? state.allRegistrations.filter(
                (item) => item.status === "Enrollment Complete"
              )
            : state.completedRegistrations,
        terminatedRegistrations:
          payload === "terminated"
            ? state.allRegistrations.filter(
                (item) => item.status === "Enrollment Terminated"
              )
            : state.terminatedRegistrations,
        registrationListStatus: {
          ...{
            regular: false,
            terminated: false,
            completed: false,
          },
          [payload]: true,
        },
      };
    case GET_REGISTRATION:
      return {
        ...state,
        registration: payload,
      };
    case CLEAR_REGISTRATION:
      return {
        ...state,
        registration: {},
      };
    case AGE_FILTER:
      return {
        ...state,
        filteredRegistrations:
          state.searchFiltered.length > 0
            ? state.searchFiltered.filter((item) => {
                return payload === "Under" ? item.age < 18 : item.age >= 18;
              })
            : state.enrollmentFiltered.length > 0
            ? state.enrollmentFiltered.filter((item) => {
                return payload === "Under" ? item.age < 18 : item.age >= 18;
              })
            : state.registrationListStatus.regular
            ? state.registrations.filter((item) => {
                return payload === "Under" ? item.age < 18 : item.age >= 18;
              })
            : state.registrationListStatus.completed
            ? state.completedRegistrations.filter((item) => {
                return payload === "Under" ? item.age < 18 : item.age >= 18;
              })
            : state.terminatedRegistrations.filter((item) => {
                return payload === "Under" ? item.age < 18 : item.age >= 18;
              }),
        ageFiltered: state.registrationListStatus.regular
          ? state.registrations.filter((item) => {
              return payload === "Under" ? item.age < 18 : item.age >= 18;
            })
          : state.registrationListStatus.completed
          ? state.completedRegistrations.filter((item) => {
              return payload === "Under" ? item.age < 18 : item.age >= 18;
            })
          : state.terminatedRegistrations.filter((item) => {
              return payload === "Under" ? item.age < 18 : item.age >= 18;
            }),
        ageOver: payload === "Over",
        ageUnder: payload === "Under",
      };
    case "ENROLLMENT_FILTER":
      return {
        ...state,
        filteredRegistrations:
          state.searchFiltered.length > 0 && state.ageFiltered.length > 0
            ? state.filteredRegistrations.filter((item) => {
                return payload === "REGULAR"
                  ? item.registerForIntercession === false
                  : item.registerForIntercession === true;
              })
            : state.searchFiltered.length > 0
            ? state.searchFiltered.filter((item) => {
                return payload === "REGULAR"
                  ? item.registerForIntercession === false
                  : item.registerForIntercession === true;
              })
            : state.ageFiltered.length > 0
            ? state.ageFiltered.filter((item) => {
                return payload === "REGULAR"
                  ? item.registerForIntercession === false
                  : item.registerForIntercession === true;
              })
            : state.registrationListStatus.regular
            ? state.registrations.filter((item) => {
                return payload === "REGULAR"
                  ? item.registerForIntercession === false
                  : item.registerForIntercession === true;
              })
            : state.registrationListStatus.completed
            ? state.completedRegistrations.filter((item) => {
                return payload === "REGULAR"
                  ? item.registerForIntercession === false
                  : item.registerForIntercession === true;
              })
            : state.terminatedRegistrations.filter((item) => {
                return payload === "REGULAR"
                  ? item.registerForIntercession === false
                  : item.registerForIntercession === true;
              }),
        enrollmentFiltered: state.registrationListStatus.regular
          ? state.registrations.filter((item) => {
              return payload === "REGULAR"
                ? item.registerForIntercession === false
                : item.registerForIntercession === true;
            })
          : state.registrationListStatus.completed
          ? state.completedRegistrations.filter((item) => {
              return payload === "REGULAR"
                ? item.registerForIntercession === false
                : item.registerForIntercession === true;
            })
          : state.terminatedRegistrations.filter((item) => {
              return payload === "REGULAR"
                ? item.registerForIntercession === false
                : item.registerForIntercession === true;
            }),
        regularEnrollmentOnly: payload === "REGULAR",
        intercessionEnrollmentOnly: payload === "INTERCESSION",
      };

    case SEARCH_FILTER:
      const regex = new RegExp(`${payload}`, "gi");

      const filteredRegistrations =
        state.ageFiltered.length > 0 && state.enrollmentFiltered.length > 0
          ? state.filteredRegistrations.filter((item) => {
              return (
                (item.firstName && item.firstName.match(regex)) ||
                (item.lastName && item.lastName.match(regex)) ||
                (item.age && item.age.match(regex)) ||
                (item.studentPrimaryPhone && item.studentPrimaryPhone.match(regex)) ||
                (item.studentEmail && item.studentEmail.match(regex)) ||
                (item.learningCenterName && item.learningCenterName.match(regex)) ||
                (item.learningCenterCharter && item.learningCenterCharter.match(regex)) ||
                (item.learningCenterAddress && item.learningCenterAddress.match(regex)) ||
                (item.pgRelationshipToStudent && item.pgRelationshipToStudent.match(regex)) ||
                (item.pgLastName && item.pgLastName.match(regex)) ||
                (item.pgFirstName && item.pgFirstName.match(regex)) ||
                (item.status && item.status.match(regex))
              );
            })
          : state.ageFiltered.length > 0
          ? state.ageFiltered.filter((item) => {
              return (
                (item.firstName && item.firstName.match(regex)) ||
                (item.lastName && item.lastName.match(regex)) ||
                (item.age && item.age.match(regex)) ||
                (item.studentPrimaryPhone && item.studentPrimaryPhone.match(regex)) ||
                (item.studentEmail && item.studentEmail.match(regex)) ||
                (item.learningCenterName && item.learningCenterName.match(regex)) ||
                (item.learningCenterCharter && item.learningCenterCharter.match(regex)) ||
                (item.learningCenterAddress && item.learningCenterAddress.match(regex)) ||
                (item.pgRelationshipToStudent && item.pgRelationshipToStudent.match(regex)) ||
                (item.pgLastName && item.pgLastName.match(regex)) ||
                (item.pgFirstName && item.pgFirstName.match(regex)) ||
                (item.status && item.status.match(regex))
              );
            })
          : state.registrationListStatus.regular
          ? state.registrations.filter((item) => {
              return (
                (item.firstName && item.firstName.match(regex)) ||
                (item.lastName && item.lastName.match(regex)) ||
                (item.age && item.age.match(regex)) ||
                (item.studentPrimaryPhone && item.studentPrimaryPhone.match(regex)) ||
                (item.studentEmail && item.studentEmail.match(regex)) ||
                (item.learningCenterName && item.learningCenterName.match(regex)) ||
                (item.learningCenterCharter && item.learningCenterCharter.match(regex)) ||
                (item.learningCenterAddress && item.learningCenterAddress.match(regex)) ||
                (item.pgRelationshipToStudent && item.pgRelationshipToStudent.match(regex)) ||
                (item.pgLastName && item.pgLastName.match(regex)) ||
                (item.pgFirstName && item.pgFirstName.match(regex)) ||
                (item.status && item.status.match(regex))
              );
            })
          : state.registrationListStatus.completed
          ? state.completedRegistrations.filter((item) => {
              return (
                (item.firstName && item.firstName.match(regex)) ||
                (item.lastName && item.lastName.match(regex)) ||
                (item.age && item.age.match(regex)) ||
                (item.studentPrimaryPhone && item.studentPrimaryPhone.match(regex)) ||
                (item.studentEmail && item.studentEmail.match(regex)) ||
                (item.learningCenterName && item.learningCenterName.match(regex)) ||
                (item.learningCenterCharter && item.learningCenterCharter.match(regex)) ||
                (item.learningCenterAddress && item.learningCenterAddress.match(regex)) ||
                (item.pgRelationshipToStudent && item.pgRelationshipToStudent.match(regex)) ||
                (item.pgLastName && item.pgLastName.match(regex)) ||
                (item.pgFirstName && item.pgFirstName.match(regex)) ||
                (item.status && item.status.match(regex))
              );
            })
          : state.terminatedRegistrations.filter((item) => {
              return (
                (item.firstName && item.firstName.match(regex)) ||
                (item.lastName && item.lastName.match(regex)) ||
                (item.age && item.age.match(regex)) ||
                (item.studentPrimaryPhone && item.studentPrimaryPhone.match(regex)) ||
                (item.studentEmail && item.studentEmail.match(regex)) ||
                (item.learningCenterName && item.learningCenterName.match(regex)) ||
                (item.learningCenterCharter && item.learningCenterCharter.match(regex)) ||
                (item.learningCenterAddress && item.learningCenterAddress.match(regex)) ||
                (item.pgRelationshipToStudent && item.pgRelationshipToStudent.match(regex)) ||
                (item.pgLastName && item.pgLastName.match(regex)) ||
                (item.pgFirstName && item.pgFirstName.match(regex)) ||
                (item.status && item.status.match(regex))
              );
            });

      const searchFiltered =
        filteredRegistrations.length > 0
          ? filteredRegistrations
          : ["No data found"];

      return {
        ...state,
        filteredRegistrations,
        searchFiltered,
      };

    case CLEAR_AGE_FILTER:
      return {
        ...state,
        ageOver: false,
        ageUnder: false,
        ageFiltered: [],
        filteredRegistrations:
          state.searchFiltered.length > 0 && state.enrollmentFiltered.length > 0
            ? state.regularEnrollmentOnly
              ? state.searchFiltered.filter((item) => {
                  return item.registerForIntercession === false;
                })
              : state.searchFiltered.filter((item) => {
                  return item.registerForIntercession === true;
                })
            : state.searchFiltered.length > 0
            ? state.searchFiltered
            : state.enrollmentFiltered.length > 0
            ? state.enrollmentFiltered
            : [],
      };
    case "CLEAR_ENROLLMENT_FILTER":
      return {
        ...state,
        regularEnrollmentOnly: false,
        intercessionEnrollmentOnly: false,
        enrollmentFiltered: [],
        filteredRegistrations:
          state.searchFiltered.length > 0 && state.ageFiltered.length > 0
            ? state.ageOver
              ? state.searchFiltered.filter((item) => {
                  return item.age >= 18;
                })
              : state.searchFiltered.filter((item) => {
                  return item.age < 18;
                })
            : state.searchFiltered.length > 0
            ? state.searchFiltered
            : state.ageFiltered.length > 0
            ? state.ageFiltered
            : [],
      };
    case CLEAR_SEARCH_FILTER:
      return {
        ...state,
        filteredRegistrations:
          state.ageFiltered.length > 0 && state.enrollmentFiltered.length > 0
            ? state.ageOver
              ? state.enrollmentFiltered.filter((item) => {
                  return item.age >= 18;
                })
              : state.enrollmentFiltered.filter((item) => {
                  return item.age < 18;
                })
            : state.ageFiltered.length > 0
            ? state.ageFiltered
            : state.enrollmentFiltered.length > 0
            ? state.enrollmentFiltered
            : [],
        searchFiltered: [],
      };
    case UPDATE_REGISTRATION:
      return {
        ...state,
        registrations: state.registrations.map((registration) =>
          registration._id === action.payload._id
            ? action.payload
            : registration
        ),
        allRegistrations: state.allRegistrations.map((registration) =>
          registration._id === action.payload._id
            ? action.payload
            : registration
        ),
      };
    case DELETE_REGISTRATION:
      return {
        ...state,
        registrations: state.registrations.filter(
          (registration) => registration._id !== action.payload
        ),
        allRegistrations: state.allRegistrations.filter(
          (registration) => registration._id !== action.payload
        ),
      };
    case SET_LIST_VIEW:
      return {
        ...state,
        listView: payload,
      };
    case FILTER_TABLE:
      let asc = state.sortOptions[payload].asc === false;
      let normal = state.sortOptions[payload].desc === true;
      return {
        ...state,
        registrations: normal
          ? state.registrations.sort((a, b) =>
              a["createdAt"] < b["createdAt"] ? 1 : -1
            )
          : asc
          ? state.registrations.sort((a, b) =>
              a[payload] > b[payload] ? 1 : -1
            )
          : state.registrations.sort((a, b) =>
              a[payload] < b[payload] ? 1 : -1
            ),
        filteredRegistrations:
          state.filteredRegistrations.length > 0
            ? normal
              ? state.filteredRegistrations.sort((a, b) =>
                  a["createdAt"] < b["createdAt"] ? 1 : -1
                )
              : asc
              ? state.filteredRegistrations.sort((a, b) =>
                  a[payload] > b[payload] ? 1 : -1
                )
              : state.filteredRegistrations.sort((a, b) =>
                  a[payload] < b[payload] ? 1 : -1
                )
            : [],
        sortOptions: {
          ...{
            createdAt: { asc: false, desc: false },
            age: { asc: false, desc: false },
            firstName: { asc: false, desc: false },
            status: { asc: false, desc: false },
            registerForIntercession: { asc: false, desc: false },
            studentEmail: { asc: false, desc: false },
            studentPrimaryPhone: { asc: false, desc: false },
            learningCenterName: { asc: false, desc: false },
          },
          [payload]: normal
            ? { asc: false, desc: false }
            : asc
            ? { asc: true, desc: false }
            : { asc: false, desc: true },
        },
      };
    case "FILTER_ORIENTATION_TABLE":
      let ascOrientation = state.orientationSortOptions[payload].asc === false;
      let normalOrientation =
        state.orientationSortOptions[payload].desc === true;
      return {
        ...state,
        scheduledOrientations: normalOrientation
          ? state.scheduledOrientations.sort((a, b) =>
              a["orientationTime"] > b["orientationTime"] ? 1 : -1
            )
          : ascOrientation
          ? state.scheduledOrientations.sort((a, b) =>
              a[payload] > b[payload] ? 1 : -1
            )
          : state.scheduledOrientations.sort((a, b) =>
              a[payload] < b[payload] ? 1 : -1
            ),
        orientationSortOptions: {
          ...{
            action: { asc: false, desc: false },
            orientationTime: { asc: false, desc: false },
            // orientationTime: { asc: false, desc: false },
            age: { asc: false, desc: false },
            firstName: { asc: false, desc: false },
            status: { asc: false, desc: false },
            registerForIntercession: { asc: false, desc: false },
            learningCenterName: { asc: false, desc: false },
            programs: { asc: false, desc: false },
            moreInfo: { asc: false, desc: false },
          },
          [payload]: normalOrientation
            ? { asc: false, desc: false }
            : ascOrientation
            ? { asc: true, desc: false }
            : { asc: false, desc: true },
        },
      };
    case CLEAR_FILTER_TABLE:
      return {
        ...state,
        sortOptions: {
          createdAt: { asc: false, desc: false },
          age: { asc: false, desc: false },
          firstName: { asc: false, desc: false },
          status: { asc: false, desc: false },
          registerForIntercession: { asc: false, desc: false },
          studentEmail: { asc: false, desc: false },
          studentPrimaryPhone: { asc: false, desc: false },
          learningCenterName: { asc: false, desc: false },
        },
      };
    case "CLEAR_STATUS_FILTER":
      return {
        ...state,
        completedRegistrations: [],
        terminatedRegistrations: [],
        ageOver: false,
        ageUnder: false,
        filteredRegistrations: [],
        ageFiltered: [],
        enrollmentFiltered: [],
        searchFiltered: [],
      };
    case SET_FORM_MODAL:
      return {
        ...state,
        formModal: { ...state.formModal, [payload.name]: payload.value },
      };
    case "SET_MATCH_LOADING":
      return {
        ...state,
        studentMatchLoading: true,
      };
    case "GET_STUDENT_MATCH":
      return {
        ...state,
        studentMatchResults: payload,
        studentMatchLoading: false,
      };
    case "STUDENT_MATCH_ERROR":
      return {
        ...state,
        studentMatchLoading: false,
        studentMatchResults: [],
      };
    case "CLEAR_STUDENT_MATCH_RESULTS":
      return {
        ...state,
        studentMatchResults: [],
      };
    case "GET_STATUS_TYPES":
      return {
        ...state,
        statusTypes: payload,
      };
    case "PRE_REGISTRATION_STATUS_UPDATE":
      return {
        ...state,
        formData: {
          ...state.formData,
          status: payload.status,
          progressLevel: payload.progressLevel,
          processingLevel: payload.processingLevel,
        },
      };
    case "POST_REGISTRATION_STATUS_UPDATE":
      return {
        ...state,
        registration: {
          ...state.registration,
          status: payload.status,
          progressLevel: payload.progressLevel,
          processingLevel: payload.processingLevel,
        },
      };
    case "BATCH_STATUS_UPDATE":
      return {
        ...state,
        scheduledOrientations: state.scheduledOrientations.filter(
          (item) => !payload.includes(item._id)
        ),
      };
    case "UPDATE_ORIENTATION":
      const { msg, type } = payload;
      return {
        ...state,
        alertMessage: msg,
        registration: {
          ...state.registration,
          status:
            type === "VIRTUAL"
              ? "Virtual Orientation Sent"
              : "Orientation Scheduled",
        },
      };
    case "TOGGLE_SUB_MENU":
      return {
        ...state,
        sidebarStatus: {
          ...{
            forms: false,
            actions: false,
          },
          [payload]: state.sidebarStatus[payload] ? false : true,
        },
      };
    case "GET_ORIENTATION_INFO":
      return {
        ...state,
        orientation_info: payload,
      };
    case "CLOSE_NOTIFICATION_BANNER":
      return {
        ...state,
        notificationBanner: {
          visible: false,
          type: "warning",
          message: "",
        },
      };
    case "SET_ALERT":
      return {
        ...state,
        notificationBanner: {
          visible: true,
          type: payload.msgType,
          message: payload.msg,
        },
      };
    case "UPDATE_FORM_STATUS":
      return {
        ...state,
        formData: { ...state.formData, status: payload },
      };
    case "UPDATE_PROCESSING_LEVEL":
      return {
        ...state,
        registration: { ...state.registration, processingLevel: payload },
      };
    case "ADD_SPECIAL_PROGRAMS":
      return {
        ...state,
        registration: {
          ...state.registration,
          processingLevel: 3,
          progressLevel: 2,
          programs: payload.programList,
          programDescription: payload.programDescription,
        },
      };
    case "POST_SCHEDULE_ORIENTATION":
      return {
        ...state,
        registration: {
          ...state.registration,
          processingLevel: 2,
          progressLevel: 2,
          status: "Orientation Scheduled",
        },
        notificationBanner: {
          visible: true,
          type: payload.msgType,
          message: payload.msg,
        },
      };
    case "TERMINATE_ENROLLMENT":
      return {
        ...state,
        registration: {
          ...state.registration,
          status: "Enrollment Terminated",
          progressLevel: 3,
          processingLevel: 2,
          terminationNotes: payload,
        },
      };
    case "UPDATE_REGISTRATION_FORM":
      return {
        ...state,
        registration: payload,
      };
    case "TRANSFER_INTEREST_TO_REGISTRATION":
      return {
        ...state,
        formData: {
          ...state.formData,
          firstName: payload.studentFirstName,
          lastName: payload.studentLastName,
          birthDate: moment(payload.birthDate).format("YYYY-MM-DD"),
          age: payload.age,
          pgRelationshipToStudent: payload.parentRelationship,
          pgFirstName: payload.parentFirstName,
          pgLastName: payload.parentLastName,
          studentEmail: payload.age >= 18 ? payload.primaryEmail : "",
          pgPrimaryEmail: payload.age < 18 ? payload.primaryEmail : "",
          studentPrimaryPhone: payload.age >= 18 ? payload.phone : "",
          pgPrimaryPhone: payload.age < 18 ? payload.phone : "",
          street: `${payload.street1} ${
            payload.street2 !== "" ? payload.street2 : ""
          }`,
          city: payload.city,
          state: payload.state,
          zip: payload.zipCode,
          isMailingAddressTheSame: {
            yes: payload.sameAddress,
            no: !payload.sameAddress,
          },
          mailingStreet: `${payload.malingStreet1} ${
            payload.mailingStreet2 !== "" ? payload.mailingStreet2 : ""
          }`,
          mailingCity: payload.mailingCity,
          mailingState: payload.mailingState,
          mailingZip: payload.mailingZipCode,
          learningCenterName: payload.learningCenterName,
          _uuid: payload._uuid,
          learningCenterCharter: payload.learningCenterCharter,
          learningCenterAddress: payload.learningCenterAddress,
          learningCenterCoordinates: payload.learningCenterCoordinates,
          learningCenterId: payload.learningCenterId,
        },
      };

    case GET_REGISTRATION_ENTRIES:
      return {
        ...state,
        registrations: payload,
        allRegistrations: action.allRegistrations || payload,
        totalCount: action.totalCount,
        appliedFilters: action.appliedFilters,
        currentFilters: {
          charterName: action.learningCenterCharter,
          learningCenterName: action.learningCenterName,
          status: action.status,
          age: action.age,
          searchText: action.searchText,
          startDate: action.startDate,
          endDate: action.endDate,
          allTime: action.allTime,
        },
        loading: false,
      };

    case SET_CURRENT_PAGE:
      return {
        ...state,
        currentPage: payload,
      };

    case "TOGGLE_COLUMN":
      return {
        ...state,
        visibleColumns: {
          ...state.visibleColumns,
          [payload]: !state.visibleColumns[payload],
        },
      };

    case SET_LOADING_REG:
      return {
        ...state,
        loading: true,
      };

    case "SET_SEARCH_TEXT":
      return {
        ...state,
        searchText: payload,
        currentFilters: {
          ...state.currentFilters,
          searchText: payload,
        },
      };

    default:
      return state;
  }
};

export default adminRegistrationReducer;
